var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/ld+json"},domProps:{"innerHTML":_vm._s(this.jsonlddados)}})}
var staticRenderFns = []

export { render, staticRenderFns }